export default __webpack_public_path__ + "static/media/score_bg_header.8eef07c8.png";